import { BaseStorage } from './base-storage';
export class DataCapsule extends BaseStorage {
    constructor({ strategy, ...options }) {
        super();
        this.storageStrategy = BaseStorage.verify(strategy);
        this._options = options;
    }
    async setItem(key, value, options) {
        const validOptions = this._buildValidateOptions(this._options, options);
        return this.storageStrategy.setItem(key, value, validOptions);
    }
    getItem(key, options) {
        const validOptions = this._buildValidateOptions(this._options, options);
        return this.storageStrategy.getItem(key, validOptions);
    }
    removeItem(key, options) {
        const validOptions = this._buildValidateOptions(this._options, options);
        return this.storageStrategy.removeItem(key, validOptions);
    }
    getAllItems(options) {
        const validOptions = this._buildValidateOptions(this._options, options);
        return this.storageStrategy.getAllItems(validOptions);
    }
    _buildValidateOptions(capsuleOptions, options) {
        options = { ...capsuleOptions, ...options };
        options.scope = this.storageStrategy.extendScope(options.scope);
        if (!validateNamespace(options)) {
            throw new Error('namespace is required and should be a string');
        }
        return options;
    }
}
function validateNamespace(options) {
    return typeof options.namespace === 'string';
}
//# sourceMappingURL=data-capsule.js.map